import { checkRights } from '../../services/acl';
import { redirect } from 'react-router-dom';
import { useAppSelector } from '../hooks';
import { authoritiesListSelector } from '../../store/selectors';
import store from '../../store/store';

export const permissionsGuard = (target: string[]) => {
  const authoritiesList = store.getState().auth.authoritiesList;
  if (authoritiesList && !checkRights(authoritiesList || [], target)) {
    return redirect('/*');
  }
  return true;
};

export const permissionsCheck = (target: string[]) => {
  const authoritiesList = store.getState().auth.authoritiesList;
  if (authoritiesList && checkRights(authoritiesList, target)) {
    return true;
  }
  return false;
};
